import { createSvgIcon } from '@mui/material';

const ReturnIcon = createSvgIcon(
  <svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22.6784" cy="22.9097" r="22.2312" fill="white" />
    <path
      d="M34.2847 17.9317L36.448 15.7761C36.448 15.7761 35.0519 12.2295 30.0342 9.30951L27.871 11.4651L30.3798 13.9649L29.82 14.5228C24.3186 9.83979 16.0388 10.494 11.339 15.9827C9.3002 18.3656 8.18748 21.4026 8.2013 24.5361C8.23586 31.7533 14.1381 37.5726 21.3743 37.5382C28.6174 37.5038 34.4575 31.6225 34.4229 24.4121C34.4091 21.32 33.2964 18.338 31.2783 15.9896L31.8381 15.4318L34.2847 17.9317ZM31.5616 24.3226C31.5064 29.9835 26.8481 34.5287 21.167 34.4667C15.4859 34.4116 10.9244 29.77 10.9866 24.1091C11.0419 18.4757 15.6517 13.9443 21.3121 13.9649C27.0071 14.02 31.5824 18.6479 31.5686 24.3226H31.5616Z"
      fill="#85C440"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.034 17.8926C19.2291 18.0881 19.2287 18.4046 19.0332 18.5997L16.4289 21.1978H24.7339C26.9211 21.1978 28.6942 22.9651 28.6942 25.15C28.6942 27.3348 26.9211 29.1021 24.7339 29.1021H11.0647C10.7886 29.1021 10.5647 28.8783 10.5647 28.6021C10.5647 28.326 10.7886 28.1021 11.0647 28.1021H24.7339C26.371 28.1021 27.6942 26.7803 27.6942 25.15C27.6942 23.5197 26.371 22.1978 24.7339 22.1978H16.4289L19.0332 24.796C19.2287 24.9911 19.2291 25.3076 19.034 25.5031C18.839 25.6986 18.5224 25.699 18.3269 25.504L14.8666 22.0518C14.7726 21.958 14.7198 21.8307 14.7198 21.6978C14.7198 21.565 14.7726 21.4377 14.8666 21.3439L18.3269 17.8917C18.5224 17.6967 18.839 17.6971 19.034 17.8926Z"
      fill="#323634"
    />
  </svg>,
  'ReturnIcon',
);

export default ReturnIcon;
